import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { choosePhoneFromList } from './mobile-steps'
import {
  chooseBrandsAndroidPhoneSearch,
  chooseBrandsPhoneSearch,
  choosePhoneCondition,
  // chooseBrandsProprietaryPhoneSearch,
  choosePhoneOsPhoneSearch,
  provincesStepPhoneSearch,
} from './phone-search-steps'

export const phoneSearchScenarioA: Scenario = {
  id: 'phone-search-a',
  initialStep: Steps.CHOOSE_PHONE_OS,
  type: ScenarioType.PHONE_SEARCH,
  version: '1',
  milestones: [
    choosePhoneOsPhoneSearch.id,
    chooseBrandsPhoneSearch.id,
    choosePhoneCondition.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStepPhoneSearch,
    choosePhoneOsPhoneSearch,
    chooseBrandsPhoneSearch,
    chooseBrandsAndroidPhoneSearch,
    // chooseBrandsProprietaryPhoneSearch,
    choosePhoneCondition,
    choosePhoneFromList,
  ],
  weight: 1,
}
